import React from 'react'
import classNames from 'classnames'

import './styles.scss'

const Avatar = ({ imageUrl, className, small }) => {
  const avatarClassNames = classNames('community_avatar', className, {
    'community_avatar--small': small,
  })

  return (
    <>
      {imageUrl ? (
        <img className={avatarClassNames} src={imageUrl} alt='avatar' />
      ) : (
        <i className={`fas fa-user community_avatar community_avatar--no-avatar ${avatarClassNames}`} />
      )}
    </>
  )
}
export default Avatar
